import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../services/language.service';
import { BaseComponent } from '../BaseComponent';

@Component({
  selector: 'lib-home-section-skeleton',
  templateUrl: './home-section-skeleton.component.html',
  styleUrls: ['./home-section-skeleton.component.css']
})
export class HomeSectionSkeletonComponent extends BaseComponent implements OnInit {



  constructor(
    private lang_s: LanguageService
  ) {
    super(lang_s);
  }






}
